import {Injector} from "@angular/core";

/**
 * Can injects a service, in a similar way to the default angular DI, but at will.
 * Helps injecting services to base classes, without having to pass everything from the child class
 */
export class ServiceInjectorService {
    static injector: Injector = null;
}
